<template>
  <div class="everyday-answer">
    <a-skeleton avatar active :paragraph="{ rows: 3 }" :loading="loadState" />
    <template v-if="todayAnswer.length > 0 && loadState === false">
      <div
        class="answer-item"
        v-for="(item, index) in todayAnswer"
        :key="index"
        :class="{ 'last-answer-item': index == todayAnswer.length - 1 }"
        @click="lookAnswerDetail(item)"
      >
        <div class="user-photo">
          <img
            :src="item.user_info.avatar ? item.user_info.avatar : defaultImg"
          />
        </div>
        <div class="right-content">
          <p class="answer-author">
            <span>{{ item.user_info.username }}</span>
            <span>{{ item.created_at }}</span>
          </p>
          <p class="for-course" @click="lookDetail(item)">
            #{{ item.content_info.title }}#
          </p>
          <p class="answer-detail">{{ item.answer }}</p>
          <div class="comment-actions">
            <p class="left-set">
              <span
                class="private-mark"
                v-if="getDeleteState(item.user_id) && item.is_private == '1'"
                >{{ $t("yearCourse.onlyMe") }}</span
              >
            </p>
            <p class="right-btn-group">
              <span
                :class="
                  item.is_favorite ? 'anticon-collect' : 'anticon-uncollect'
                "
                @click.stop="collectComment(item)"
                >{{ item.favorite_num }}</span
              >
              <span
                :class="item.is_praise ? 'anticon-like' : 'anticon-unlike'"
                @click.stop="praiseComment(item)"
                >{{ item.praise_num }}</span
              >
            </p>
          </div>
        </div>
      </div>
    </template>
    <div
      v-else-if="todayAnswer.length === 0 && loadState === false"
      class="null-answer"
    >
      <img src="@/assets/img/new/no-date.png" />
      <p>{{ $t("yearCourse.nullContents") }}</p>
    </div>
    <p
      class="look-all"
      @click="lookAllComment"
      v-if="todayAnswer.length > 0 || loadState"
    >
      {{ $t("columnVideo.seeMore") }}
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 加载状态
      loadState: true,
      // 默认头像
      defaultImg: require("@/assets/img/learning_camp/basic_fc.png"),
      todayAnswer: [],
    };
  },
  created() {
    this.getTodayAnswer();
  },
  activated() {
    this.loadState = true;
    this.getTodayAnswer();
  },
  methods: {
    getTodayAnswer() {
      this.$axios
        .post(`index.php/mobile/learn-map/daily-reflect-list`, {
          page: 1,
          size: 10,
        })
        .then((res) => {
          this.loadState = false;
          if (res.data.code === 0) {
            this.todayAnswer = res.data.result.list.slice(0, 2);
          } else {
            this.$toast(res.data.msg);
          }
        });
    },
    // 查看全部
    lookAllComment() {
      this.$router.push({ path: "/main/365allAnswer" });
    },
    // 查看详情
    lookDetail() {
      return;
      // this.$router.push({path: '/main/365course', query: {
      //     cid: item.content_id,
      //     tid: item.trainplan_id,
      //     rid: item.resources_id,
      // }})
    },
    // 查看每日一省详情
    lookAnswerDetail(item) {
      this.$router.push({
        path: "/main/365AnswerDetail",
        query: {
          cid: item.content_id,
          tid: item.trainplan_id,
          rid: item.resources_id,
          id: item.user_id,
        },
      });
    },
    getDeleteState(id) {
      if (id == localStorage._user_data_id) {
        return true;
      } else {
        return false;
      }
    },
    // 点赞每日一省
    praiseComment(item) {
      this.$axios
        .post(`index.php/mobile/praise/item`, {
          item: item.id,
          type: "15",
          trainplan_id: item.trainplan_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            item.praise_num = res.data.result.is_praise
              ? Number(item.praise_num) + 1
              : Number(item.praise_num) - 1;
            if (item.praise_num < 0) item.praise_num = 0;
            item.is_praise = res.data.result.is_praise;
          } else {
            this.$toast(res.data.msg);
          }
        });
    },
    // 收藏每日一省
    collectComment(item) {
      this.$axios
        .post(`index.php/mobile/favorite/item`, {
          item: item.id,
          type: "15",
          trainplan_id: item.trainplan_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            item.favorite_num = res.data.result.is_favorite
              ? Number(item.favorite_num) + 1
              : Number(item.favorite_num) - 1;
            if (item.favorite_num < 0) item.favorite_num = 0;
            item.is_favorite = res.data.result.is_favorite;
          } else {
            this.$toast(res.data.msg);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/sass/color.less";

.everyday-answer {
  /deep/ .ant-skeleton-with-avatar {
    width: 87%;
    margin: 0.4rem auto;
  }
  .look-all {
    background: white;
    color: @mColor;
    text-align: center;
    font-size: 0.22rem;
    line-height: 0.66rem;
    border-top: 0.02rem solid #ddd;
  }
}
.answer-item {
  display: flex;
  padding: 0.3rem 0.3rem 0.24rem;
  border-bottom: #eee 0.02rem solid;
  .user-photo {
    width: 0.76rem;
    height: 0.76rem;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 0.3rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .right-content {
    flex: 1;
    overflow: hidden;
    .answer-author {
      display: flex;
      justify-content: space-between;
      span:nth-child(1) {
        font-size: 0.26rem;
        font-weight: 700;
        max-width: 4rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span:nth-child(2) {
        font-size: 0.22rem;
        color: #7f8485;
      }
    }
    .for-course {
      color: @mColor;
      font-size: 0.24rem;
      margin: 0.1rem 0 0.2rem;
    }
    .answer-detail {
      font-size: 0.26rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      /*! autoprefixer: off */
      -webkit-box-orient: vertical;
      /*autoprefixer: on */
    }
    .comment-actions {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 0.2rem;
      font-size: 0.26rem;
      span {
        display: inline-block;
      }
      .private-mark {
        padding-left: 0.3rem;
        background: url("~@/assets/img/survey/private.png") no-repeat left
          center;
        background-size: 0.2rem;
        font-size: 0.22rem;
        color: #a9aeaf;
      }
      .anticon-like {
        background: url("~@/assets/img/learning_camp/like_cur.png") no-repeat
          left top;
        background-size: 0.35rem;
        padding-left: 0.4rem;
        margin-left: 0.3rem;
      }
      .anticon-unlike {
        .anticon-like;
        background: url("~@/assets/img/learning_camp/praise.png") no-repeat left
          top;
        background-size: 0.35rem;
      }
      .anticon-collect {
        background: url("~@/assets/img/learning_camp/faved.png") no-repeat left
          top;
        background-size: 0.35rem;
        padding-left: 0.4rem;
      }
      .anticon-uncollect {
        .anticon-collect;
        background: url("~@/assets/img/learning_camp/fav2.png") no-repeat left
          top;
        background-size: 0.35rem;
      }
    }
  }
}
.last-answer-item {
  border-bottom: none;
}
.null-answer {
  text-align: center;
  padding: 0.5rem 0;
  color: #888;
  font-size: 0.26rem;
  img {
    width: 1.8rem;
    margin: 0 auto 0.3rem;
  }
}
</style>
